import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   grades:[]
}

const classSlice = createSlice({
    name: "class",
    initialState,
    reducers: {
        setclass: (state, action) => {
            state.grades = action.payload;
        },

        removeClass: (state, action) => {
            const { id } = action.payload;
            state.grades = state.grades.filter((item) => item.id !== id);
          }
       
    }
});

export const { setclass,removeClass } = classSlice.actions;
export default classSlice.reducer;